import React, { useState } from 'react';
import { PrimaryButtonPurple, PrimaryButtonGreen, SecondaryButtonOutline } from '../ui/Buttons';
import { AlignLeft, AlignCenter, AlignRight, Eye, Lock, Trash2 } from 'lucide-react';
export function TextPanel() {
  const [hasText, setHasText] = useState(false);
  const [outline, setOutline] = useState(false);
  const [outlineWidth, setOutlineWidth] = useState(2);
  return <div className="h-full flex flex-col" data-id="element-321">
      <div className="p-4 border-b border-gray-100" data-id="element-322">
        <h2 className="font-semibold text-gray-900" data-id="element-323">Text</h2>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-324">
        {!hasText ? <PrimaryButtonPurple className="w-full" onClick={() => setHasText(true)} data-id="element-325">
            Add text
          </PrimaryButtonPurple> : <div className="space-y-4" data-id="element-326">
            <input type="text" defaultValue="Your Text Here" className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:ring-2 focus:ring-violet-500 outline-none" data-id="element-327" />

            <div className="grid grid-cols-2 gap-2" data-id="element-328">
              <select className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" data-id="element-329">
                <option data-id="element-330">Inter</option>
                <option data-id="element-331">Roboto</option>
                <option data-id="element-332">Lobster</option>
              </select>
              <input type="number" defaultValue={48} className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" data-id="element-333" />
            </div>

            <div className="flex items-center gap-2" data-id="element-334">
              <div className="w-8 h-8 rounded border border-gray-200 bg-black cursor-pointer" data-id="element-335" />
              <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-336">
                <button className="p-2 hover:bg-gray-50 border-r border-gray-200" data-id="element-337">
                  <AlignLeft size={16} data-id="element-338" />
                </button>
                <button className="p-2 hover:bg-gray-50 border-r border-gray-200 bg-gray-50" data-id="element-339">
                  <AlignCenter size={16} data-id="element-340" />
                </button>
                <button className="p-2 hover:bg-gray-50" data-id="element-341">
                  <AlignRight size={16} data-id="element-342" />
                </button>
              </div>
            </div>

            <div className="border-t border-gray-100 pt-4" data-id="element-343">
              <div className="flex items-center justify-between mb-2" data-id="element-344">
                <span className="text-sm font-medium text-gray-700" data-id="element-345">
                  Outline
                </span>
                <button onClick={() => setOutline(!outline)} className={`w-11 h-6 rounded-full transition-colors relative ${outline ? 'bg-violet-600' : 'bg-gray-200'}`} data-id="element-346">
                  <div className={`w-4 h-4 bg-white rounded-full absolute top-1 transition-transform ${outline ? 'left-6' : 'left-1'}`} data-id="element-347" />
                </button>
              </div>

              {outline && <input type="range" min="0" max="10" value={outlineWidth} onChange={e => setOutlineWidth(Number(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-violet-600 mt-2" data-id="element-348" />}
            </div>

            <div className="flex gap-2 pt-4" data-id="element-349">
              <PrimaryButtonGreen className="flex-1" data-id="element-350">Apply</PrimaryButtonGreen>
              <button className="p-2 text-red-600 border border-red-200 rounded-lg hover:bg-red-50" data-id="element-351">
                <Trash2 size={20} data-id="element-352" />
              </button>
            </div>
          </div>}

        {/* Layers List */}
        {hasText && <div className="border-t border-gray-100 pt-4" data-id="element-353">
            <h3 className="text-xs font-semibold text-gray-500 uppercase mb-2" data-id="element-354">
              Layers
            </h3>
            <div className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border border-gray-100" data-id="element-355">
              <span className="text-sm font-medium text-gray-700" data-id="element-356">
                Your Text Here
              </span>
              <div className="flex items-center gap-2 text-gray-400" data-id="element-357">
                <button className="hover:text-gray-600" data-id="element-358">
                  <Eye size={14} data-id="element-359" />
                </button>
                <button className="hover:text-gray-600" data-id="element-360">
                  <Lock size={14} data-id="element-361" />
                </button>
                <button className="hover:text-red-600" onClick={() => setHasText(false)} data-id="element-362">
                  <Trash2 size={14} data-id="element-363" />
                </button>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}